var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header',{attrs:{"id":"header"}}),_vm._v(" "),_c('div',{attrs:{"id":"main"}},[_c('router-view'),_vm._v(" "),_c('Footer'),_vm._v(" "),_c('GoTop'),_vm._v(" "),_c('Service'),_vm._v(" "),_c('JoinUs',{attrs:{"visible":_vm.showJoinUs},on:{"update:visible":function($event){_vm.showJoinUs=$event}}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9be978f8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 